import * as React from "react";
import { useGetLocationsQuery } from "../services/location.service";
import { Location } from "../types/location";
import SelectData from "./global/SelectData";
import { useUILabel } from "../hooks/useUILabel";

const SelectLocation = ({
  onChange,
  sx,
  value,
  label,
  error,
  helperText,
}: {
  onChange: (arg?: number) => void;
  sx?: any;
  value: number;
  label?: string;
  error?: boolean;
  helperText?: React.ReactNode;
}) => {
  const defaultLocationLabel = useUILabel("common.location");
  const {
    data: locations,
    isLoading,
    isFetching,
  } = useGetLocationsQuery({
    sortField: "name",
    sortMode: "asc",
  });

  return (
    <SelectData
      data={locations?.data}
      getOptionLabel={(location) => `${location.name} [ ${location.city}, ${location.state} ]`}
      getOptionValue={(location) => location.id}
      value={value}
      onChange={(value) => onChange(value as number)}
      label={label || defaultLocationLabel}
      error={error}
      helperText={helperText}
      isLoading={isLoading}
      isFetching={isFetching}
      sx={sx}
    />
  );
};
export default SelectLocation;
